// Locked product wordmark recipe — Air[gent in copper] + product name in steel-blue.
// CSS in landing.css under .product-wordmark.
// Sizes: 'xs' (22px, nav/footer) · 'sm' (24px) · 'md' (36px, section title) · 'lg' (64px default).

export type WordmarkSize = 'xs' | 'sm' | 'md' | 'lg';

export default function Wordmark({ name, size = 'lg' }: { name?: string; size?: WordmarkSize }) {
  const sizeClass = size === 'lg' ? '' : size;
  return (
    <span className={`product-wordmark ${sizeClass}`.trim()}>
      <span className="brand">Air<span className="gent">gent</span></span>
      {name ? <span className="name">{name}</span> : null}
    </span>
  );
}
